/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ValorizationType = 'NONE' | 'INFLATION' | 'VALORIZATION_FIXED_AMOUNT' | 'VALORIZATION_PERCENTAGE';

export const ValorizationType = {
    NONE: 'NONE' as ValorizationType,
    INFLATION: 'INFLATION' as ValorizationType,
    VALORIZATION_FIXED_AMOUNT: 'VALORIZATION_FIXED_AMOUNT' as ValorizationType,
    VALORIZATION_PERCENTAGE: 'VALORIZATION_PERCENTAGE' as ValorizationType
};

